import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import './UnsubscribePage.css';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';

function UnsubscribePage() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const uid = searchParams.get('uid');
    const token = searchParams.get('token');

    if (!uid || !token) {
      setStatus('error');
      setMessage('Invalid unsubscribe link.');
      return;
    }

    const unsubscribe = async () => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/api/winback/unsubscribe?uid=${encodeURIComponent(uid)}&token=${encodeURIComponent(token)}`
        );
        if (!response.ok) {
          const data = await response.json().catch(() => ({}));
          throw new Error(data.detail || 'Failed to unsubscribe.');
        }
        setStatus('success');
        setMessage("You've been unsubscribed. You won't receive any more emails from this sequence.");
      } catch (err) {
        setStatus('error');
        setMessage('Something went wrong.');
      }
    };

    unsubscribe();
  }, [searchParams]);

  return (
    <div className="unsubscribe-page">
      <div className="unsubscribe-card">
        <div className="unsubscribe-logo">Latted</div>
        {status === 'loading' && (
          <p className="unsubscribe-message">Unsubscribing...</p>
        )}
        {status === 'success' && (
          <>
            <h2 className="unsubscribe-title">Unsubscribed</h2>
            <p className="unsubscribe-message">{message}</p>
          </>
        )}
        {status === 'error' && (
          <>
            <h2 className="unsubscribe-title">Oops</h2>
            <p className="unsubscribe-message unsubscribe-error">{message}</p>
          </>
        )}
        <a href="/" className="unsubscribe-home-link">Back to Latted</a>
      </div>
    </div>
  );
}

export default UnsubscribePage;
